import React, { memo, useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { TabView, TabPanel } from 'primereact/tabview';
import { MATHTYPES }  from 'components/HHQComponents';
import ViewMath from '../../ViewMath';
import './index.css';

// @ts-ignore
import { MathfieldElement } from 'mathlive';

interface MathTypeItem {
  className: string;
  imageUrl?: string;
  math: string;
}

interface MathGroup {
  name: string;
  maths: MathTypeItem[];
}

interface Props {
  handleInsertMath: (latex: string) => void;
}

const MathEditorComponent: React.FC<Props> = ({ handleInsertMath }) => {
  const mathFieldRef = useRef<MathfieldElement | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [latex, setLatex] = useState<string>('');

  useEffect(() => {
    setTimeout(() => {
      const mf = new MathfieldElement();
      mf.smartMode = true;
      mf.smartSuperscript = true;
      mf.value = 'a^2 + b^2 = c^2';
      mf.style.width = '100%';
      mf.style.height = '50px';

      if (containerRef.current) {
        containerRef.current.innerHTML = '';
        containerRef.current.appendChild(mf);
        mathFieldRef.current = mf;
      }

      mf.addEventListener('input', () => {
        setLatex(mf.getValue());
      });
    }, 100); // Delay slight for layout stability

    return () => {
      mathFieldRef.current?.remove();
    };
  }, []);

  const handleMathInsert = (math: string) => {
    mathFieldRef.current?.executeCommand('insert', math);
    setLatex(mathFieldRef.current?.getValue() || '');
  };

  return (
    <div className="math_container">
      <div className="math_tab">
        <TabView>
          {MATHTYPES.map((group: MathGroup, groupIndex: number) => (
            <TabPanel header={group.name} key={`group-${groupIndex}`}>
              {group.maths.map((item, itemIndex) => (
                <button
                  className="btn_math"
                  key={`math-item-${itemIndex}-${item.className}`}
                  onClick={() => handleMathInsert(item.math)}
                >
                  <img
                    className={item.className}
                    src={
                      item.imageUrl
                        ? `/images/mathtype/${item.imageUrl}.png`
                        : '/images/mathtype/icons-mathjax.png'
                    }
                    alt="math"
                  />
                </button>
              ))}
            </TabPanel>
          ))}
        </TabView>
      </div>

      <div className="math_content mt-2" style={{ maxWidth: 600, overflowX: 'auto' }}>
        <div ref={containerRef} />
      </div>

      <div className="math_view mt-2 bg-white p-3">
        <p>Kết quả là:</p>
        <div className="text-center font-size-25">
          <ViewMath>
            <div
              dangerouslySetInnerHTML={{
                __html: `<span class="math-tex">\\(${latex}\\)</span>`,
              }}
            />
          </ViewMath>
        </div>
      </div>

      <div className="math_action mt-3 text-right">
        <Button
          icon="pi pi-language"
          label="Chèn biểu thức"
          onClick={() => handleInsertMath(latex)}
        />
      </div>
    </div>
  );
};

export default memo(MathEditorComponent);
